module.exports = __webpack_public_path__ + "img/yext.c8b155ee.png";